export enum IntegrationCertificateEnum {
  P12 = 'application/x-pkcs12',
}
